var mailToCoupon, mailToMerchant, trimString;

if (window.Coupons == null) {
  window.Coupons = {};
}

$(function() {
  return Coupons.showShareModal = function(coupon) {
    var shareModal;
    if (!coupon) {
      return false;
    }
    shareModal = $('#couponShareModal');
    shareModal.find('.merchant-name').html(coupon.merchant).end().find('.coupon-title').html(coupon.title);
    GIG.Modal.open({
      el: shareModal
    });
    Coupons.couponShareOptions(coupon);
    return false;
  };
});

mailToMerchant = function() {
  var body, subj, url;
  Coupons.merchantShareOptions();
  subj = encodeURIComponent("" + Coupons.share.title);
  body = encodeURIComponent(I18n.t('js.modules.coupons.share.promo_code', {
    merchantName: Coupons.share.merchantName,
    shareUrl: Coupons.share.url
  }));
  url = "mailto:?subject=" + subj + "&body=" + body;
  $('.merchant-share-links .share-over-email').attr('href', url);
  window.location.href = url;
  return false;
};

mailToCoupon = function() {
  var body, subj, url;
  subj = encodeURIComponent(I18n.t('js.modules.coupons.share.mail_subject', {
    merchantName: Coupons.share.merchantName
  }));
  body = encodeURIComponent(I18n.t('js.modules.coupons.share.mail_body', {
    merchantName: Coupons.share.merchantName,
    title: Coupons.share.title,
    url: Coupons.share.url
  }));
  url = "mailto:?subject=" + subj + "&body=" + body;
  $('#couponShareModal .share-over-email').attr('href', url);
  window.open(url, '_blank');
  return false;
};

Coupons.couponShareOptions = function(coupon) {
  if (!coupon) {
    return false;
  }
  Coupons.share = {};
  Coupons.share = {
    url: 'https://' + window.location.host + window.location.pathname + '?c=' + coupon.couponId + '&s=1',
    title: trimString(coupon.title),
    image: coupon.image,
    merchantName: trimString(coupon.merchant)
  };
  return false;
};

Coupons.merchantShareOptions = function() {
  var merchantName, merchantSlug, storesBaseUrl;
  Coupons.share = {};
  merchantName = $(".merchant-share-links").attr('data-merchant-name');
  merchantSlug = $(".merchant-share-links").attr('data-merchant-slug');
  storesBaseUrl = $(".merchant-share-links").data('stores-base-url');
  Coupons.share = {
    merchantName: trimString(merchantName),
    merchantSlug: trimString(merchantSlug),
    title: I18n.t('js.modules.coupons.share.share_title', {
      merchantName: merchantName
    }),
    url: "https://" + window.location.host + storesBaseUrl + "/" + merchantSlug,
    image: $('.merchant-share-image').attr('src')
  };
  return false;
};

trimString = function(x) {
  return x != null ? x.replace(/^\s+|\s+$/g, "") : void 0;
};

$(function() {
  $(document).on('click', 'span.coupon-share-button', function(e) {
    var clickedOn, closestCoupon, coupon;
    e.preventDefault();
    clickedOn = $(e.currentTarget || e.srcElement);
    closestCoupon = clickedOn.closest('.coupon');
    coupon = {
      title: "" + (closestCoupon.find('.coupon-title').text()),
      merchant: "" + (closestCoupon.attr('data-merchant')),
      image: closestCoupon.find('.image-wrapper img').attr('src') || $('.merchant-logo img').attr('src') || closestCoupon.find('.image-contain img').attr('src'),
      couponId: closestCoupon.attr('data-uuid')
    };
    Coupons.showShareModal(coupon);
    return false;
  });
  $(document).on('click', '.share-on-facebook', function(e) {
    var appId, clickedOn, height, left, opts, redirect_uri, shareMerchant, top, url, width;
    clickedOn = $(e.currentTarget || e.srcElement);
    shareMerchant = $(clickedOn).parent().parent().hasClass('merchant-share-links');
    if (shareMerchant === true) {
      Coupons.merchantShareOptions();
    }
    appId = '362467757230092';
    redirect_uri = "https://" + window.location.host;
    width = 560;
    height = 480;
    left = ($(window).width() - width) / 2;
    top = ($(window).height() - height) / 2;
    opts = "status=1,width=" + width + ",height=" + height + ",top=" + top + ",left=" + left;
    url = "https://www.facebook.com/sharer.php?u=" + Coupons.share.url;
    window.open(url, "facebook", opts);
    return false;
  });
  $(document).on('click', '.share-over-email', function(e) {
    var clickedOn, shareMerchant;
    clickedOn = $(e.currentTarget || e.srcElement);
    shareMerchant = $(clickedOn).parent().hasClass('merchant-share-links');
    if (shareMerchant === true) {
      mailToMerchant();
    } else {
      mailToCoupon();
    }
    return false;
  });
  $(document).on('click', '.share-on-twitter', function(e) {
    var clickedOn, height, left, opts, shareMerchant, text, top, url, width;
    clickedOn = $(e.currentTarget || e.srcElement);
    shareMerchant = $(clickedOn).parent().parent().hasClass('merchant-share-links');
    if (shareMerchant === true) {
      Coupons.merchantShareOptions();
      text = encodeURIComponent(Coupons.share.title);
      url = ("https://twitter.com/intent/tweet?text=" + text + "&via=groupon&related=groupon&url=") + encodeURIComponent(Coupons.share.url);
    } else {
      text = encodeURIComponent(I18n.t('js.modules.coupons.share.share_text', {
        merchantName: Coupons.share.merchantName,
        title: Coupons.share.title
      }));
      url = ("https://twitter.com/intent/tweet?text=" + text + "&via=groupon&related=groupon&url=") + encodeURIComponent(Coupons.share.url);
    }
    width = 575;
    height = 400;
    left = ($(window).width() - width) / 2;
    top = ($(window).height() - height) / 2;
    opts = "status=1,width=" + width + ",height=" + height + ",top=" + top + ",left=" + left;
    window.open(url, "twitter", opts);
    return false;
  });
  $(document).on('click', '.share-on-pinterest', function(e) {
    var clickedOn, description, height, left, opts, shareMerchant, top, url, width;
    clickedOn = $(e.currentTarget || e.srcElement);
    shareMerchant = $(clickedOn).parent().parent().hasClass('merchant-share-links');
    if (shareMerchant === true) {
      Coupons.merchantShareOptions();
      Coupons.share.title = Coupons.share.title.replace('&', 'and');
      description = "" + Coupons.share.title;
    } else {
      Coupons.share.merchantName = Coupons.share.merchantName.replace('&', 'and');
      description = I18n.t('js.modules.coupons.share.share_text', {
        merchantName: Coupons.share.merchantName,
        title: Coupons.share.title
      });
    }
    width = 700;
    height = 330;
    left = ($(window).width() - width) / 2;
    top = ($(window).height() - height) / 2;
    url = "https://pinterest.com/pin/create/button/?url=" + encodeURIComponent(Coupons.share.url) + ("&media=" + Coupons.share.image + "&description=") + encodeURIComponent(description);
    opts = "status=1,width=" + width + ",height=" + height + ",top=" + top + ",left=" + left;
    window.open(url, "pinterest", opts);
    return false;
  });
  return $(document).on('click', '.share-on-gplus', function(e) {
    var clickedOn, height, left, opts, shareMerchant, top, url, width;
    clickedOn = $(e.currentTarget || e.srcElement);
    shareMerchant = $(clickedOn).parent().parent().hasClass('merchant-share-links');
    if (shareMerchant === true) {
      Coupons.merchantShareOptions();
    }
    width = 520;
    height = 430;
    left = ($(window).width() - width) / 2;
    top = ($(window).height() - height) / 2;
    url = 'https://plus.google.com/share?url=' + Coupons.share.url;
    opts = "status=1,width=" + width + ",height=" + height + ",top=" + top + ",left=" + left;
    window.open(url, "gplus", opts);
    return false;
  });
});

